import styles from './styles.css';
import TradeInCustomElement from '../../TradeInCustomElement';

class CustomElement extends TradeInCustomElement {
  getStyles() {
    return styles.toString();
  }
}

customElements.define('tradein-widget', CustomElement);

if (module.hot) {
  // Accept hot module reloads for styles, could be moved to a custom webpack plugin
  module.hot.accept('./styles.css', () => {
    document
      .querySelectorAll<CustomElement>('tradein-widget')
      .forEach((element) => element.updateStylesheet());
  });
}
